package com.qrkontaq.ui.sections.footer.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.theme.AppColors
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

@Composable
internal fun HorizontalDivider() {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        Modifier
            .fillMaxWidth()
            .height(1.px)
            .backgroundColor(colors.divider)
            .opacity(0.3)
            .margin(topBottom = 1.5.cssRem)
    )
}
